import { api } from '@/lib/axios';

export interface AdminLoginRequest { username: string; password: string; }
export interface AdminLoginResponse {
  userName: string;
  userKey: number;
  permissions: string[];
  // No token field — JWT is stored server-side in BFF session
  csrfToken?: string;
  idleTimeoutMinutes: number;
  idleExpiresAt: string;
  absoluteExpiresAt: string;
}

export type AdminSessionTimingResponse = AdminLoginResponse;

export interface AdminPortalStatus {
  enabled: boolean;
}

export const authService = {
  getStatus: () =>
    api.get<AdminPortalStatus>('/admin/Authentication/Status').then(r => r.data),

  login: (req: AdminLoginRequest) =>
    api.post<AdminLoginResponse>('/admin/Authentication/Login', req).then(r => r.data),

  logout: () =>
    api.post('/admin/Authentication/Logout').then(() => undefined),

  sessionStatus: () =>
    api.get<AdminLoginResponse>('/admin/Authentication/SessionStatus').then(r => r.data),

  recordActivity: () =>
    api.post<AdminSessionTimingResponse>('/admin/Authentication/Activity').then(r => r.data),

  initiateRecovery: (username: string) =>
    api.post('/admin/Authentication/Recovery/Initiate', { username }).then(() => undefined),

  verifyRecoveryCode: (username: string, code: string) =>
    api.post('/admin/Authentication/Recovery/Verify', { username, code }).then(() => undefined),

  resetPassword: (username: string, code: string, newPassword: string) =>
    api.post('/admin/Authentication/Recovery/ResetPassword', { username, code, newPassword }).then(() => undefined),
};
